import { Text, View } from "@react-pdf/renderer";
import { FunctionComponent } from "react";

type Props = {
  totalWeight: number;
  totalHechura: string;
  totalQuantity: number;
};

const DetailedItemTotal: FunctionComponent<Props> = ({
  totalHechura,
  totalWeight,
  totalQuantity,
}) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline",
      fontSize: "8px",
      width: "100%",
      fontFamily: "Mont-Regular",
      paddingBottom: "10px",
      paddingTop: "10px",
      backgroundColor: "#F5F5F5",
    }}
  >
    <Text
      style={{
        width: "68%",
        position: "relative",
        left: "15rem",
      }}
    >
      {totalQuantity}
    </Text>
    <Text
      style={{
        width: "10%",
      }}
    >
      Total:
    </Text>
    <Text
      style={{
        width: "11%",
      }}
    >
      {totalWeight} gr
    </Text>
    <Text
      style={{
        width: "11%",
      }}
    >
      {totalHechura}
    </Text>
  </View>
);

export default DetailedItemTotal;
